export default __webpack_public_path__ + "static/media/l13.f942748e.jpg";